import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardEvent from "./CardEvent";
import { leftArrow, liveIcon, rightArrow } from "../../../constants/icons";
import { useSelector } from "react-redux";
import { convertISOToReadable } from "../../../../helpers/datetime_helper";
import { BASE_URL } from "../../../../constants/config";
import { imageSrc } from "../../../../helpers/url_helper";

function UpcomingEventsCarousel({ className, upcomingEvents }) {
  const ref = useRef(null);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const paths = useSelector((state) => state.user.paths);
  const upcomingEventsData = upcomingEvents.map((value) => {
    let dataMap = {
      className: (new Date() > new Date(value.bce_end_date) ? 'expired' : ''),
      eventImage: imageSrc('event', value.bce_thumbnail, paths),
      eventType: value?.bce_delivered_type === 'venue' ? 'Offline' : value?.bce_delivered_type === 'live' ? 'Live' : '',
      eventTitle: value?.bce_name,
      eventDeadline: `Deadline: ${value.bce_end_date ? convertISOToReadable(value.bce_end_date, 'short', false) : ''}`,
      eventButton: value?.bce_delivered_type === 'venue' ? 'View Event Details' : 'View Event Session',
      eventStartLink: `/student-dashboard/events/${value?.bce_slug}`,
      linkToCopy: `${BASE_URL}student-dashboard/events/${value?.bce_slug}`
    }
  return dataMap;
});
  
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    afterChange: (current) => {
      setIsAtStart(current === 0);
      setIsAtEnd(current === upcomingEventsData.length - 1);
    },
  };

  const handleNextSlide = () => {
    ref.current.slickNext();
  };

  const handlePrevSlide = () => {
    ref.current.slickPrev();
  };

  return (
    <>
      <div className={`${className || ""} upcoming-events-wrapper`}>
        <div className="myk_stu-carousel-action">
          <a href="#" className={`btn-move btn-prev ${isAtStart ? 'disabled' : ''}`} onClick={handlePrevSlide}>
            {leftArrow}
          </a>
          <a href="#" className={`btn-move btn-btn-next ${isAtEnd ? 'disabled' : ''}`} onClick={handleNextSlide}>
            {rightArrow}
          </a>
        </div>
        <Slider {...settings} ref={ref} className="upcomingevents-slider">
          {upcomingEventsData.map((event, index) => (
            <CardEvent key={index} {...event} />
          ))}
        </Slider>
      </div>
    </>
  );
}

export default UpcomingEventsCarousel;
